import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import {createSidebar, createSuperadminSidebar} from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import RegionsFlyout from "../../flyouts/superadmin/regions/RegionsFlyout";
import {
	deleteRegions,
	listRegions,
	readRegion,
} from "../../redux/actions/table/superadmin/regions";
import { listLocalization } from "../../redux/actions/localization";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_regions"],
	auth: state.auth,
}))
class Regions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_region && setPlusActions([{
			title: "Add region",
			onClick: () => setTableParams('superadmin_regions', {
				add_region_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readRegion(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin } = this.props;

		let columns = [
			{
				key: "name",
				name: "Name",
				required: true,
				value: name => (
					<Tooltip text={name}>{name}</Tooltip>
				)
			},
		];

		const singleActions = (region_id) => {
			return [
				<Tooltip text="Delete selected region" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected region?\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteRegions([region_id]).then(() => {
												hideAlertbox();

												setNotification("The selected region has been deleted.");
												listRegions();

												listLocalization();

												setTableParams('superadmin_regions', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (regions_ids) => [
			<Tooltip text="Delete selected regions" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these regions?\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteRegions(regions_ids).then(() => {
											hideAlertbox();

											setNotification("The selected regions have been deleted.");
											listRegions();

											listLocalization();

											setTableParams('superadmin_regions', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<RegionsFlyout
				data={this.state.preview}
				readAction={region_id => {
					return new Promise(resolve => {
						readRegion(getURLParam('id') || region_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listRegions}
				name="superadmin_regions"
				groupActions={superadmin.delete_region && groupActions}
				singleActions={superadmin.delete_region && singleActions}
				title={__("modules.submodules.title.regions")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default Regions;
